import {
  MAX_CAMPAIGN_CODE_QUANTITY,
  MAX_CAMPAIGN_DESIGNATOR_LENGTH,
  MIN_CAMPAIGN_DESIGNATOR_LENGTH,
} from "../constants.js";

export function validateCampaignStep(form, step) {
  const errors = {};
  const designator = String(form.campaignPrefix || "").trim().toUpperCase();
  const name = String(form.campaignName || "").trim();
  const quantity = Number(form.requestedCodeQuantity);

  if (step === 1 || step === 3) {
    if (!designator) {
      errors.campaignPrefix = "Generate or enter a campaign designator.";
    } else if (
      !new RegExp(
        `^[A-Z0-9]{${MIN_CAMPAIGN_DESIGNATOR_LENGTH},${MAX_CAMPAIGN_DESIGNATOR_LENGTH}}$`
      ).test(designator)
    ) {
      errors.campaignPrefix = `${MIN_CAMPAIGN_DESIGNATOR_LENGTH}–${MAX_CAMPAIGN_DESIGNATOR_LENGTH} uppercase letters or numbers.`;
    }
    if (!name) errors.campaignName = "Enter a campaign name.";
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(form.fromDate || ""))) {
      errors.fromDate = "Select a valid start date.";
    }
    if (form.toDate && !/^\d{4}-\d{2}-\d{2}$/.test(String(form.toDate))) {
      errors.toDate = "Select a valid end date.";
    } else if (form.toDate && form.fromDate && form.toDate < form.fromDate) {
      errors.toDate = "End date cannot be before the start date.";
    }
  }

  if (step === 2 || step === 3) {
    if (!Number.isInteger(quantity) || quantity < 1) {
      errors.requestedCodeQuantity = "Enter a whole number greater than zero.";
    } else if (quantity > MAX_CAMPAIGN_CODE_QUANTITY) {
      errors.requestedCodeQuantity = `Quantity cannot exceed ${MAX_CAMPAIGN_CODE_QUANTITY.toLocaleString()}.`;
    }
  }

  return errors;
}
